import {getMethod, postMethod, putMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/ownTransferServiceCategories', request)
}

async function post(request) {
    return await postMethod('/api/ownTransferServiceCategories', request)
}

async function put(request) {
    return await putMethod('/api/ownTransferServiceCategories', request)
}

export {get, post, put}
